import EnterPayment from './EnterPayment'

export default function PaymentAdd() {

   const header = 'Add a Payment Method'
   const message = 'Please add a payment method to participate in this auction. By placing a bid, you agree to pay the full amount of your bid.'
   const buttonText = 'Add Payment Card'

  return (
    <>
      <EnterPayment header={header} message={message} buttonText={buttonText} />
    </>
  )
}